module.exports = __webpack_public_path__ + "static/img/banner-perfil-home-1024x768.1384d2c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banners/banner-perfil-home-1024x768.jpg
// module id = c/py
// module chunks = 47